import { between, required, shape } from '@totalsoft/pure-validations';

export const leasingCommissionValidator = shape({
  commissionCode: required,
  commissionName: required,
  calcTypeId: required,
  commissionPercent: between(0, 100),
  commissionValue: between(0, 100000)
});
